@file:OptIn(InternalResourceApi::class)

package top.clientapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.clientapp.generated.resources/"

@delegate:ResourceContentHash(-890_565_100)
internal val Res.string.onboarding_next: StringResource by lazy {
      StringResource("string:onboarding_next", "onboarding_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16553, 35),
      ))
    }

@delegate:ResourceContentHash(-521_526_923)
internal val Res.string.onboarding_reviews_description: StringResource by lazy {
      StringResource("string:onboarding_reviews_description", "onboarding_reviews_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16589, 174),
      ))
    }

@delegate:ResourceContentHash(1_195_446_782)
internal val Res.string.onboarding_reviews_title: StringResource by lazy {
      StringResource("string:onboarding_reviews_title", "onboarding_reviews_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16764, 84),
      ))
    }

@delegate:ResourceContentHash(329_342_722)
internal val Res.string.onboarding_share_description: StringResource by lazy {
      StringResource("string:onboarding_share_description", "onboarding_share_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16849, 192),
      ))
    }

@delegate:ResourceContentHash(678_948_259)
internal val Res.string.onboarding_share_title: StringResource by lazy {
      StringResource("string:onboarding_share_title", "onboarding_share_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17042, 90),
      ))
    }

@delegate:ResourceContentHash(-1_029_282_067)
internal val Res.string.onboarding_skip: StringResource by lazy {
      StringResource("string:onboarding_skip", "onboarding_skip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17133, 51),
      ))
    }

@delegate:ResourceContentHash(-312_158_759)
internal val Res.string.onboarding_start_description: StringResource by lazy {
      StringResource("string:onboarding_start_description", "onboarding_start_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17185, 128),
      ))
    }

@delegate:ResourceContentHash(1_413_660_026)
internal val Res.string.onboarding_start_title: StringResource by lazy {
      StringResource("string:onboarding_start_title", "onboarding_start_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17314, 62),
      ))
    }

@delegate:ResourceContentHash(-2_130_562_339)
internal val Res.string.venue_category_accounting_audit: StringResource by lazy {
      StringResource("string:venue_category_accounting_audit", "venue_category_accounting_audit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17377, 83),
      ))
    }

@delegate:ResourceContentHash(-914_878_095)
internal val Res.string.venue_category_aesthetic_medicine: StringResource by lazy {
      StringResource("string:venue_category_aesthetic_medicine", "venue_category_aesthetic_medicine", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17461, 113),
      ))
    }

@delegate:ResourceContentHash(1_917_805_102)
internal val Res.string.venue_category_auto_parts: StringResource by lazy {
      StringResource("string:venue_category_auto_parts", "venue_category_auto_parts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17575, 73),
      ))
    }

@delegate:ResourceContentHash(-69_699_553)
internal val Res.string.venue_category_bakery_confectionery: StringResource by lazy {
      StringResource("string:venue_category_bakery_confectionery", "venue_category_bakery_confectionery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17649, 99),
      ))
    }

@delegate:ResourceContentHash(1_712_227_600)
internal val Res.string.venue_category_bank_credit: StringResource by lazy {
      StringResource("string:venue_category_bank_credit", "venue_category_bank_credit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17749, 86),
      ))
    }

@delegate:ResourceContentHash(1_333_903_486)
internal val Res.string.venue_category_bar_pub: StringResource by lazy {
      StringResource("string:venue_category_bar_pub", "venue_category_bar_pub", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17836, 58),
      ))
    }

@delegate:ResourceContentHash(-972_079_789)
internal val Res.string.venue_category_barbershop: StringResource by lazy {
      StringResource("string:venue_category_barbershop", "venue_category_barbershop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17895, 61),
      ))
    }

@delegate:ResourceContentHash(-995_983_941)
internal val Res.string.venue_category_bookstore_stationery: StringResource by lazy {
      StringResource("string:venue_category_bookstore_stationery", "venue_category_bookstore_stationery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17957, 95),
      ))
    }

@delegate:ResourceContentHash(30_071_189)
internal val Res.string.venue_category_bowling_billiards: StringResource by lazy {
      StringResource("string:venue_category_bowling_billiards", "venue_category_bowling_billiards", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18053, 84),
      ))
    }

@delegate:ResourceContentHash(1_749_174_075)
internal val Res.string.venue_category_breakfast_brunch: StringResource by lazy {
      StringResource("string:venue_category_breakfast_brunch", "venue_category_breakfast_brunch", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18138, 107),
      ))
    }

@delegate:ResourceContentHash(-1_729_457_700)
internal val Res.string.venue_category_business_consulting: StringResource by lazy {
      StringResource("string:venue_category_business_consulting", "venue_category_business_consulting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18246, 86),
      ))
    }

@delegate:ResourceContentHash(1_448_578_697)
internal val Res.string.venue_category_car_dealership: StringResource by lazy {
      StringResource("string:venue_category_car_dealership", "venue_category_car_dealership", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18333, 65),
      ))
    }

@delegate:ResourceContentHash(465_378_379)
internal val Res.string.venue_category_car_insurance: StringResource by lazy {
      StringResource("string:venue_category_car_insurance", "venue_category_car_insurance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18399, 108),
      ))
    }

@delegate:ResourceContentHash(514_144_325)
internal val Res.string.venue_category_car_service: StringResource by lazy {
      StringResource("string:venue_category_car_service", "venue_category_car_service", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18508, 78),
      ))
    }

@delegate:ResourceContentHash(647_662_866)
internal val Res.string.venue_category_car_wash: StringResource by lazy {
      StringResource("string:venue_category_car_wash", "venue_category_car_wash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18587, 55),
      ))
    }

@delegate:ResourceContentHash(614_327_862)
internal val Res.string.venue_category_catering_delivery: StringResource by lazy {
      StringResource("string:venue_category_catering_delivery", "venue_category_catering_delivery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18643, 100),
      ))
    }

@delegate:ResourceContentHash(-396_684_627)
internal val Res.string.venue_category_cinema: StringResource by lazy {
      StringResource("string:venue_category_cinema", "venue_category_cinema", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18744, 57),
      ))
    }

@delegate:ResourceContentHash(-1_422_468_049)
internal val Res.string.venue_category_cleaning: StringResource by lazy {
      StringResource("string:venue_category_cleaning", "venue_category_cleaning", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18802, 83),
      ))
    }

@delegate:ResourceContentHash(15_378_761)
internal val Res.string.venue_category_clinic_gp: StringResource by lazy {
      StringResource("string:venue_category_clinic_gp", "venue_category_clinic_gp", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18886, 104),
      ))
    }

@delegate:ResourceContentHash(492_600_235)
internal val Res.string.venue_category_clothing_shoes: StringResource by lazy {
      StringResource("string:venue_category_clothing_shoes", "venue_category_clothing_shoes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18991, 73),
      ))
    }

@delegate:ResourceContentHash(1_269_371_446)
internal val Res.string.venue_category_coffee_shop: StringResource by lazy {
      StringResource("string:venue_category_coffee_shop", "venue_category_coffee_shop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19065, 54),
      ))
    }

@delegate:ResourceContentHash(-2_055_508_489)
internal val Res.string.venue_category_construction_company: StringResource by lazy {
      StringResource("string:venue_category_construction_company", "venue_category_construction_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19120, 95),
      ))
    }

@delegate:ResourceContentHash(1_752_128_696)
internal val Res.string.venue_category_construction_materials: StringResource by lazy {
      StringResource("string:venue_category_construction_materials", "venue_category_construction_materials", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19216, 113),
      ))
    }

@delegate:ResourceContentHash(-1_146_373_130)
internal val Res.string.venue_category_copywriting_translation: StringResource by lazy {
      StringResource("string:venue_category_copywriting_translation", "venue_category_copywriting_translation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19330, 106),
      ))
    }

@delegate:ResourceContentHash(1_120_168_710)
internal val Res.string.venue_category_cosmetics_perfumery: StringResource by lazy {
      StringResource("string:venue_category_cosmetics_perfumery", "venue_category_cosmetics_perfumery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19437, 102),
      ))
    }

@delegate:ResourceContentHash(74_512_828)
internal val Res.string.venue_category_cosmetology: StringResource by lazy {
      StringResource("string:venue_category_cosmetology", "venue_category_cosmetology", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19540, 66),
      ))
    }

@delegate:ResourceContentHash(2_057_790_310)
internal val Res.string.venue_category_courier_service: StringResource by lazy {
      StringResource("string:venue_category_courier_service", "venue_category_courier_service", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19607, 82),
      ))
    }

@delegate:ResourceContentHash(-1_452_575_506)
internal val Res.string.venue_category_coworking: StringResource by lazy {
      StringResource("string:venue_category_coworking", "venue_category_coworking", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19690, 60),
      ))
    }

@delegate:ResourceContentHash(-1_910_612_931)
internal val Res.string.venue_category_dentistry: StringResource by lazy {
      StringResource("string:venue_category_dentistry", "venue_category_dentistry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19751, 64),
      ))
    }

@delegate:ResourceContentHash(2_007_422_658)
internal val Res.string.venue_category_dog_training: StringResource by lazy {
      StringResource("string:venue_category_dog_training", "venue_category_dog_training", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19816, 67),
      ))
    }

@delegate:ResourceContentHash(-75_516_378)
internal val Res.string.venue_category_dress_rental: StringResource by lazy {
      StringResource("string:venue_category_dress_rental", "venue_category_dress_rental", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19884, 95),
      ))
    }

@delegate:ResourceContentHash(1_777_289_258)
internal val Res.string.venue_category_dry_cleaning: StringResource by lazy {
      StringResource("string:venue_category_dry_cleaning", "venue_category_dry_cleaning", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19980, 79),
      ))
    }

@delegate:ResourceContentHash(677_807_859)
internal val Res.string.venue_category_electronics: StringResource by lazy {
      StringResource("string:venue_category_electronics", "venue_category_electronics", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20060, 86),
      ))
    }

@delegate:ResourceContentHash(-977_828_828)
internal val Res.string.venue_category_equipment_rental: StringResource by lazy {
      StringResource("string:venue_category_equipment_rental", "venue_category_equipment_rental", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20147, 75),
      ))
    }

@delegate:ResourceContentHash(1_319_401_445)
internal val Res.string.venue_category_event_agency: StringResource by lazy {
      StringResource("string:venue_category_event_agency", "venue_category_event_agency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20223, 115),
      ))
    }

@delegate:ResourceContentHash(-511_874_624)
internal val Res.string.venue_category_event_catering: StringResource by lazy {
      StringResource("string:venue_category_event_catering", "venue_category_event_catering", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20339, 85),
      ))
    }

@delegate:ResourceContentHash(-544_998_350)
internal val Res.string.venue_category_event_photo_video: StringResource by lazy {
      StringResource("string:venue_category_event_photo_video", "venue_category_event_photo_video", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20425, 96),
      ))
    }

@delegate:ResourceContentHash(872_226_043)
internal val Res.string.venue_category_fast_food: StringResource by lazy {
      StringResource("string:venue_category_fast_food", "venue_category_fast_food", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20522, 44),
      ))
    }

@delegate:ResourceContentHash(-177_814_111)
internal val Res.string.venue_category_flower_shop: StringResource by lazy {
      StringResource("string:venue_category_flower_shop", "venue_category_flower_shop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20567, 78),
      ))
    }

@delegate:ResourceContentHash(-619_465_192)
internal val Res.string.venue_category_furniture_decor: StringResource by lazy {
      StringResource("string:venue_category_furniture_decor", "venue_category_furniture_decor", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20646, 70),
      ))
    }

@delegate:ResourceContentHash(1_005_282_515)
internal val Res.string.venue_category_gas_station_ev: StringResource by lazy {
      StringResource("string:venue_category_gas_station_ev", "venue_category_gas_station_ev", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20717, 89),
      ))
    }

@delegate:ResourceContentHash(866_182_506)
internal val Res.string.venue_category_grocery_supermarket: StringResource by lazy {
      StringResource("string:venue_category_grocery_supermarket", "venue_category_grocery_supermarket", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20807, 130),
      ))
    }

@delegate:ResourceContentHash(376_683_326)
internal val Res.string.venue_category_grooming: StringResource by lazy {
      StringResource("string:venue_category_grooming", "venue_category_grooming", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20938, 51),
      ))
    }

@delegate:ResourceContentHash(1_883_698_135)
internal val Res.string.venue_category_hairdresser: StringResource by lazy {
      StringResource("string:venue_category_hairdresser", "venue_category_hairdresser", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20990, 58),
      ))
    }

@delegate:ResourceContentHash(1_066_376_788)
internal val Res.string.venue_category_hall_rental: StringResource by lazy {
      StringResource("string:venue_category_hall_rental", "venue_category_hall_rental", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21049, 66),
      ))
    }

@delegate:ResourceContentHash(1_055_117_942)
internal val Res.string.venue_category_heating_ac: StringResource by lazy {
      StringResource("string:venue_category_heating_ac", "venue_category_heating_ac", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21116, 101),
      ))
    }

@delegate:ResourceContentHash(1_209_892_530)
internal val Res.string.venue_category_host_dj: StringResource by lazy {
      StringResource("string:venue_category_host_dj", "venue_category_host_dj", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21218, 54),
      ))
    }

@delegate:ResourceContentHash(-1_467_852_968)
internal val Res.string.venue_category_hotel_hostel: StringResource by lazy {
      StringResource("string:venue_category_hotel_hostel", "venue_category_hotel_hostel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21273, 75),
      ))
    }

@delegate:ResourceContentHash(771_696_011)
internal val Res.string.venue_category_insurance_company: StringResource by lazy {
      StringResource("string:venue_category_insurance_company", "venue_category_insurance_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21349, 84),
      ))
    }

@delegate:ResourceContentHash(1_725_196_899)
internal val Res.string.venue_category_it_support: StringResource by lazy {
      StringResource("string:venue_category_it_support", "venue_category_it_support", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21434, 97),
      ))
    }

@delegate:ResourceContentHash(-1_580_262_804)
internal val Res.string.venue_category_keys_locks: StringResource by lazy {
      StringResource("string:venue_category_keys_locks", "venue_category_keys_locks", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21532, 65),
      ))
    }

@delegate:ResourceContentHash(-1_077_222_968)
internal val Res.string.venue_category_kids_entertainment: StringResource by lazy {
      StringResource("string:venue_category_kids_entertainment", "venue_category_kids_entertainment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21598, 117),
      ))
    }

@delegate:ResourceContentHash(1_074_210_304)
internal val Res.string.venue_category_kindergarten_school: StringResource by lazy {
      StringResource("string:venue_category_kindergarten_school", "venue_category_kindergarten_school", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21716, 90),
      ))
    }

@delegate:ResourceContentHash(-427_445_020)
internal val Res.string.venue_category_laboratory: StringResource by lazy {
      StringResource("string:venue_category_laboratory", "venue_category_laboratory", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21807, 85),
      ))
    }

@delegate:ResourceContentHash(-554_559_153)
internal val Res.string.venue_category_language_courses: StringResource by lazy {
      StringResource("string:venue_category_language_courses", "venue_category_language_courses", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21893, 87),
      ))
    }

@delegate:ResourceContentHash(-781_056_917)
internal val Res.string.venue_category_laser_hair_removal: StringResource by lazy {
      StringResource("string:venue_category_laser_hair_removal", "venue_category_laser_hair_removal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21981, 105),
      ))
    }

@delegate:ResourceContentHash(-1_242_108_268)
internal val Res.string.venue_category_legal_notary: StringResource by lazy {
      StringResource("string:venue_category_legal_notary", "venue_category_legal_notary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22087, 79),
      ))
    }

@delegate:ResourceContentHash(1_383_803_335)
internal val Res.string.venue_category_manicure_pedicure: StringResource by lazy {
      StringResource("string:venue_category_manicure_pedicure", "venue_category_manicure_pedicure", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22167, 84),
      ))
    }

@delegate:ResourceContentHash(-537_385_838)
internal val Res.string.venue_category_marketing_smm_seo: StringResource by lazy {
      StringResource("string:venue_category_marketing_smm_seo", "venue_category_marketing_smm_seo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22252, 76),
      ))
    }

@delegate:ResourceContentHash(462_466_916)
internal val Res.string.venue_category_meat_dairy_shop: StringResource by lazy {
      StringResource("string:venue_category_meat_dairy_shop", "venue_category_meat_dairy_shop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22329, 90),
      ))
    }

@delegate:ResourceContentHash(-927_637_585)
internal val Res.string.venue_category_moving_service: StringResource by lazy {
      StringResource("string:venue_category_moving_service", "venue_category_moving_service", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22420, 89),
      ))
    }

@delegate:ResourceContentHash(1_811_167_741)
internal val Res.string.venue_category_music_art_school: StringResource by lazy {
      StringResource("string:venue_category_music_art_school", "venue_category_music_art_school", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22510, 119),
      ))
    }

@delegate:ResourceContentHash(-690_183_226)
internal val Res.string.venue_category_night_club: StringResource by lazy {
      StringResource("string:venue_category_night_club", "venue_category_night_club", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22630, 81),
      ))
    }

@delegate:ResourceContentHash(-1_703_714_450)
internal val Res.string.venue_category_online_courses: StringResource by lazy {
      StringResource("string:venue_category_online_courses", "venue_category_online_courses", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22712, 69),
      ))
    }

@delegate:ResourceContentHash(1_813_459_494)
internal val Res.string.venue_category_optics: StringResource by lazy {
      StringResource("string:venue_category_optics", "venue_category_optics", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22782, 45),
      ))
    }

@delegate:ResourceContentHash(-482_068_461)
internal val Res.string.venue_category_pet_hotel: StringResource by lazy {
      StringResource("string:venue_category_pet_hotel", "venue_category_pet_hotel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22828, 76),
      ))
    }

@delegate:ResourceContentHash(940_218_421)
internal val Res.string.venue_category_pet_shop: StringResource by lazy {
      StringResource("string:venue_category_pet_shop", "venue_category_pet_shop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22905, 63),
      ))
    }

@delegate:ResourceContentHash(-979_160_053)
internal val Res.string.venue_category_pharmacy: StringResource by lazy {
      StringResource("string:venue_category_pharmacy", "venue_category_pharmacy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22969, 47),
      ))
    }

@delegate:ResourceContentHash(-20_943_754)
internal val Res.string.venue_category_pizzeria: StringResource by lazy {
      StringResource("string:venue_category_pizzeria", "venue_category_pizzeria", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23017, 51),
      ))
    }

@delegate:ResourceContentHash(-565_382_706)
internal val Res.string.venue_category_plumbing_electric: StringResource by lazy {
      StringResource("string:venue_category_plumbing_electric", "venue_category_plumbing_electric", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23069, 96),
      ))
    }

@delegate:ResourceContentHash(341_854_699)
internal val Res.string.venue_category_post_delivery: StringResource by lazy {
      StringResource("string:venue_category_post_delivery", "venue_category_post_delivery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23166, 76),
      ))
    }

@delegate:ResourceContentHash(858_765_887)
internal val Res.string.venue_category_printing_copy: StringResource by lazy {
      StringResource("string:venue_category_printing_copy", "venue_category_printing_copy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23243, 92),
      ))
    }

@delegate:ResourceContentHash(-629_656_103)
internal val Res.string.venue_category_production_photo_video: StringResource by lazy {
      StringResource("string:venue_category_production_photo_video", "venue_category_production_photo_video", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23336, 101),
      ))
    }

@delegate:ResourceContentHash(-2_031_188_565)
internal val Res.string.venue_category_psychotherapy: StringResource by lazy {
      StringResource("string:venue_category_psychotherapy", "venue_category_psychotherapy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23438, 104),
      ))
    }

@delegate:ResourceContentHash(-1_130_343_384)
internal val Res.string.venue_category_quest_vr: StringResource by lazy {
      StringResource("string:venue_category_quest_vr", "venue_category_quest_vr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23543, 71),
      ))
    }

@delegate:ResourceContentHash(-1_711_503_413)
internal val Res.string.venue_category_real_estate_agency: StringResource by lazy {
      StringResource("string:venue_category_real_estate_agency", "venue_category_real_estate_agency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23615, 121),
      ))
    }

@delegate:ResourceContentHash(205_467_232)
internal val Res.string.venue_category_renovation_design: StringResource by lazy {
      StringResource("string:venue_category_renovation_design", "venue_category_renovation_design", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23737, 120),
      ))
    }

@delegate:ResourceContentHash(1_868_206_177)
internal val Res.string.venue_category_restaurant: StringResource by lazy {
      StringResource("string:venue_category_restaurant", "venue_category_restaurant", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23858, 57),
      ))
    }

@delegate:ResourceContentHash(1_569_309_310)
internal val Res.string.venue_category_shoe_clothes_repair: StringResource by lazy {
      StringResource("string:venue_category_shoe_clothes_repair", "venue_category_shoe_clothes_repair", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23916, 110),
      ))
    }

@delegate:ResourceContentHash(2_112_165_693)
internal val Res.string.venue_category_solarium: StringResource by lazy {
      StringResource("string:venue_category_solarium", "venue_category_solarium", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24027, 51),
      ))
    }

@delegate:ResourceContentHash(820_571_399)
internal val Res.string.venue_category_spa_massage: StringResource by lazy {
      StringResource("string:venue_category_spa_massage", "venue_category_spa_massage", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24079, 62),
      ))
    }

@delegate:ResourceContentHash(187_741_959)
internal val Res.string.venue_category_steak_house: StringResource by lazy {
      StringResource("string:venue_category_steak_house", "venue_category_steak_house", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24142, 82),
      ))
    }

@delegate:ResourceContentHash(901_614_383)
internal val Res.string.venue_category_sushi_asian: StringResource by lazy {
      StringResource("string:venue_category_sushi_asian", "venue_category_sushi_asian", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24225, 90),
      ))
    }

@delegate:ResourceContentHash(-472_761_198)
internal val Res.string.venue_category_tattoo_piercing: StringResource by lazy {
      StringResource("string:venue_category_tattoo_piercing", "venue_category_tattoo_piercing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24316, 74),
      ))
    }

@delegate:ResourceContentHash(-681_021_932)
internal val Res.string.venue_category_tax_consulting: StringResource by lazy {
      StringResource("string:venue_category_tax_consulting", "venue_category_tax_consulting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24391, 109),
      ))
    }

@delegate:ResourceContentHash(-1_678_876_085)
internal val Res.string.venue_category_taxi_rental: StringResource by lazy {
      StringResource("string:venue_category_taxi_rental", "venue_category_taxi_rental", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24501, 82),
      ))
    }

@delegate:ResourceContentHash(-1_274_413_079)
internal val Res.string.venue_category_tech_repair: StringResource by lazy {
      StringResource("string:venue_category_tech_repair", "venue_category_tech_repair", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24584, 98),
      ))
    }

@delegate:ResourceContentHash(602_261_251)
internal val Res.string.venue_category_tire_service: StringResource by lazy {
      StringResource("string:venue_category_tire_service", "venue_category_tire_service", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24683, 63),
      ))
    }

@delegate:ResourceContentHash(-241_183_431)
internal val Res.string.venue_category_tourism_hotels: StringResource by lazy {
      StringResource("string:venue_category_tourism_hotels", "venue_category_tourism_hotels", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24747, 101),
      ))
    }

@delegate:ResourceContentHash(395_301_405)
internal val Res.string.venue_category_training_center: StringResource by lazy {
      StringResource("string:venue_category_training_center", "venue_category_training_center", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24849, 82),
      ))
    }

@delegate:ResourceContentHash(-1_134_644_411)
internal val Res.string.venue_category_transfer_taxi: StringResource by lazy {
      StringResource("string:venue_category_transfer_taxi", "venue_category_transfer_taxi", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24932, 80),
      ))
    }

@delegate:ResourceContentHash(-135_483_760)
internal val Res.string.venue_category_travel_agency: StringResource by lazy {
      StringResource("string:venue_category_travel_agency", "venue_category_travel_agency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25013, 88),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("onboarding_next", Res.string.onboarding_next)
  map.put("onboarding_reviews_description", Res.string.onboarding_reviews_description)
  map.put("onboarding_reviews_title", Res.string.onboarding_reviews_title)
  map.put("onboarding_share_description", Res.string.onboarding_share_description)
  map.put("onboarding_share_title", Res.string.onboarding_share_title)
  map.put("onboarding_skip", Res.string.onboarding_skip)
  map.put("onboarding_start_description", Res.string.onboarding_start_description)
  map.put("onboarding_start_title", Res.string.onboarding_start_title)
  map.put("venue_category_accounting_audit", Res.string.venue_category_accounting_audit)
  map.put("venue_category_aesthetic_medicine", Res.string.venue_category_aesthetic_medicine)
  map.put("venue_category_auto_parts", Res.string.venue_category_auto_parts)
  map.put("venue_category_bakery_confectionery", Res.string.venue_category_bakery_confectionery)
  map.put("venue_category_bank_credit", Res.string.venue_category_bank_credit)
  map.put("venue_category_bar_pub", Res.string.venue_category_bar_pub)
  map.put("venue_category_barbershop", Res.string.venue_category_barbershop)
  map.put("venue_category_bookstore_stationery", Res.string.venue_category_bookstore_stationery)
  map.put("venue_category_bowling_billiards", Res.string.venue_category_bowling_billiards)
  map.put("venue_category_breakfast_brunch", Res.string.venue_category_breakfast_brunch)
  map.put("venue_category_business_consulting", Res.string.venue_category_business_consulting)
  map.put("venue_category_car_dealership", Res.string.venue_category_car_dealership)
  map.put("venue_category_car_insurance", Res.string.venue_category_car_insurance)
  map.put("venue_category_car_service", Res.string.venue_category_car_service)
  map.put("venue_category_car_wash", Res.string.venue_category_car_wash)
  map.put("venue_category_catering_delivery", Res.string.venue_category_catering_delivery)
  map.put("venue_category_cinema", Res.string.venue_category_cinema)
  map.put("venue_category_cleaning", Res.string.venue_category_cleaning)
  map.put("venue_category_clinic_gp", Res.string.venue_category_clinic_gp)
  map.put("venue_category_clothing_shoes", Res.string.venue_category_clothing_shoes)
  map.put("venue_category_coffee_shop", Res.string.venue_category_coffee_shop)
  map.put("venue_category_construction_company", Res.string.venue_category_construction_company)
  map.put("venue_category_construction_materials", Res.string.venue_category_construction_materials)
  map.put("venue_category_copywriting_translation", Res.string.venue_category_copywriting_translation)
  map.put("venue_category_cosmetics_perfumery", Res.string.venue_category_cosmetics_perfumery)
  map.put("venue_category_cosmetology", Res.string.venue_category_cosmetology)
  map.put("venue_category_courier_service", Res.string.venue_category_courier_service)
  map.put("venue_category_coworking", Res.string.venue_category_coworking)
  map.put("venue_category_dentistry", Res.string.venue_category_dentistry)
  map.put("venue_category_dog_training", Res.string.venue_category_dog_training)
  map.put("venue_category_dress_rental", Res.string.venue_category_dress_rental)
  map.put("venue_category_dry_cleaning", Res.string.venue_category_dry_cleaning)
  map.put("venue_category_electronics", Res.string.venue_category_electronics)
  map.put("venue_category_equipment_rental", Res.string.venue_category_equipment_rental)
  map.put("venue_category_event_agency", Res.string.venue_category_event_agency)
  map.put("venue_category_event_catering", Res.string.venue_category_event_catering)
  map.put("venue_category_event_photo_video", Res.string.venue_category_event_photo_video)
  map.put("venue_category_fast_food", Res.string.venue_category_fast_food)
  map.put("venue_category_flower_shop", Res.string.venue_category_flower_shop)
  map.put("venue_category_furniture_decor", Res.string.venue_category_furniture_decor)
  map.put("venue_category_gas_station_ev", Res.string.venue_category_gas_station_ev)
  map.put("venue_category_grocery_supermarket", Res.string.venue_category_grocery_supermarket)
  map.put("venue_category_grooming", Res.string.venue_category_grooming)
  map.put("venue_category_hairdresser", Res.string.venue_category_hairdresser)
  map.put("venue_category_hall_rental", Res.string.venue_category_hall_rental)
  map.put("venue_category_heating_ac", Res.string.venue_category_heating_ac)
  map.put("venue_category_host_dj", Res.string.venue_category_host_dj)
  map.put("venue_category_hotel_hostel", Res.string.venue_category_hotel_hostel)
  map.put("venue_category_insurance_company", Res.string.venue_category_insurance_company)
  map.put("venue_category_it_support", Res.string.venue_category_it_support)
  map.put("venue_category_keys_locks", Res.string.venue_category_keys_locks)
  map.put("venue_category_kids_entertainment", Res.string.venue_category_kids_entertainment)
  map.put("venue_category_kindergarten_school", Res.string.venue_category_kindergarten_school)
  map.put("venue_category_laboratory", Res.string.venue_category_laboratory)
  map.put("venue_category_language_courses", Res.string.venue_category_language_courses)
  map.put("venue_category_laser_hair_removal", Res.string.venue_category_laser_hair_removal)
  map.put("venue_category_legal_notary", Res.string.venue_category_legal_notary)
  map.put("venue_category_manicure_pedicure", Res.string.venue_category_manicure_pedicure)
  map.put("venue_category_marketing_smm_seo", Res.string.venue_category_marketing_smm_seo)
  map.put("venue_category_meat_dairy_shop", Res.string.venue_category_meat_dairy_shop)
  map.put("venue_category_moving_service", Res.string.venue_category_moving_service)
  map.put("venue_category_music_art_school", Res.string.venue_category_music_art_school)
  map.put("venue_category_night_club", Res.string.venue_category_night_club)
  map.put("venue_category_online_courses", Res.string.venue_category_online_courses)
  map.put("venue_category_optics", Res.string.venue_category_optics)
  map.put("venue_category_pet_hotel", Res.string.venue_category_pet_hotel)
  map.put("venue_category_pet_shop", Res.string.venue_category_pet_shop)
  map.put("venue_category_pharmacy", Res.string.venue_category_pharmacy)
  map.put("venue_category_pizzeria", Res.string.venue_category_pizzeria)
  map.put("venue_category_plumbing_electric", Res.string.venue_category_plumbing_electric)
  map.put("venue_category_post_delivery", Res.string.venue_category_post_delivery)
  map.put("venue_category_printing_copy", Res.string.venue_category_printing_copy)
  map.put("venue_category_production_photo_video", Res.string.venue_category_production_photo_video)
  map.put("venue_category_psychotherapy", Res.string.venue_category_psychotherapy)
  map.put("venue_category_quest_vr", Res.string.venue_category_quest_vr)
  map.put("venue_category_real_estate_agency", Res.string.venue_category_real_estate_agency)
  map.put("venue_category_renovation_design", Res.string.venue_category_renovation_design)
  map.put("venue_category_restaurant", Res.string.venue_category_restaurant)
  map.put("venue_category_shoe_clothes_repair", Res.string.venue_category_shoe_clothes_repair)
  map.put("venue_category_solarium", Res.string.venue_category_solarium)
  map.put("venue_category_spa_massage", Res.string.venue_category_spa_massage)
  map.put("venue_category_steak_house", Res.string.venue_category_steak_house)
  map.put("venue_category_sushi_asian", Res.string.venue_category_sushi_asian)
  map.put("venue_category_tattoo_piercing", Res.string.venue_category_tattoo_piercing)
  map.put("venue_category_tax_consulting", Res.string.venue_category_tax_consulting)
  map.put("venue_category_taxi_rental", Res.string.venue_category_taxi_rental)
  map.put("venue_category_tech_repair", Res.string.venue_category_tech_repair)
  map.put("venue_category_tire_service", Res.string.venue_category_tire_service)
  map.put("venue_category_tourism_hotels", Res.string.venue_category_tourism_hotels)
  map.put("venue_category_training_center", Res.string.venue_category_training_center)
  map.put("venue_category_transfer_taxi", Res.string.venue_category_transfer_taxi)
  map.put("venue_category_travel_agency", Res.string.venue_category_travel_agency)
}
